export const DATABASE_NAME = "OciusX";
export const DATABASE_VERSION = 1;